import {
    ChartingLibraryWidgetOptions,
    ResolutionString,
    Timezone,
} from '../../charting_library';

const chartConfig = {
    supported_resolutions: [
        '1' as ResolutionString,
        '5' as ResolutionString,
        '15' as ResolutionString,
        '60' as ResolutionString,
        '240' as ResolutionString,
        '1D' as ResolutionString,
    ],
    symbols: [
        {
            symbol: 'BTCUSDC',
            full_name: 'PriceFeed:BTCUSDC',
            description: 'BTCUSDC',
            exchange: 'PriceFeed',
            pricescale: 100,
        },
        {
            symbol: 'ETHUSDC',
            full_name: 'PriceFeed:ETHUSDC',
            description: 'ETHUSDC',
            exchange: 'PriceFeed',
            pricescale: 100,
        },
        {
            symbol: 'LINKUSDC',
            full_name: 'PriceFeed:LINKUSDC',
            description: 'LINKUSDC',
            exchange: 'PriceFeed',
            pricescale: 10000,
        },
        {
            symbol: 'BNBUSDC',
            full_name: 'PriceFeed:BNBUSDC',
            description: 'BNBUSDC',
            exchange: 'PriceFeed',
            pricescale: 100,
        },
        {
            symbol: 'XRPUSDC',
            full_name: 'PriceFeed:XRPUSDC',
            description: 'XRPUSDC',
            exchange: 'PriceFeed',
            pricescale: 10000,
        },
        {
            symbol: 'ADAUSDC',
            full_name: 'PriceFeed:ADAUSDC',
            description: 'ADAUSDC',
            exchange: 'PriceFeed',
            pricescale: 10000,
        },
        {
            symbol: 'MATICUSDC',
            full_name: 'PriceFeed:MATICUSDC',
            description: 'MATICUSDC',
            exchange: 'PriceFeed',
            pricescale: 10000,
        },
        {
            symbol: 'DOTUSDC',
            full_name: 'PriceFeed:DOTUSDC',
            description: 'DOTUSDC',
            exchange: 'PriceFeed',
            pricescale: 10000,
        },
        {
            symbol: 'ARBUSDC',
            full_name: 'PriceFeed:ARBUSDC',
            description: 'ARBUSDC',
            exchange: 'PriceFeed',
            pricescale: 10000,
        },
        {
            symbol: 'DOGEUSDC',
            full_name: 'PriceFeed:DOGEUSDC',
            description: 'DOGEUSDC',
            exchange: 'PriceFeed',
            pricescale: 10000,
        },
        {
            symbol: 'UNIUSDC',
            full_name: 'PriceFeed:UNIUSDC',
            description: 'UNIUSDC',
            exchange: 'PriceFeed',
            pricescale: 10000,
        },
    ],
    widgetOptions: (
        symbol: ChartingLibraryWidgetOptions['symbol'],
        datafeed: ChartingLibraryWidgetOptions['datafeed'],
        container: ChartingLibraryWidgetOptions['container']
    ) =>
        ({
            symbol,
            datafeed,
            container,
            interval: '15' as ChartingLibraryWidgetOptions['interval'],
            library_path: '/charting_library/',
            locale: 'en' as ChartingLibraryWidgetOptions['locale'],
            enabled_features: [
                localStorage.getItem('advancedMode') === 'true'
                    ? ''
                    : 'hide_left_toolbar_by_default',
            ],
            disabled_features: [
                'use_localstorage_for_settings',
                'control_bar',
                'left_toolbar',
                'timeframes_toolbar',
                'timezone_menu',
                'legend_widget',
                'header_widget',
                'main_series_scale_menu',
                'study_templates',
                'display_market_status',
                'header_undo_redo',
                'create_volume_indicator_by_default',
                'chart_crosshair_menu',
                'go_to_date',
                'symbol_info',
                'popup_hints',
                'pane_context_menu',
                'scales_context_menu',
                'legend_context_menu',
                'symbol_search_hot_key',
            ],
            charts_storage_api_version: '1.1',
            client_id: 'unlimited.leverage',
            user_id: 'unlimited_leverage',
            timezone: Intl.DateTimeFormat().resolvedOptions().timeZone as Timezone,
            fullscreen: false,
            autosize: true,
            studies_overrides: {},
            custom_css_url: '/tvchart.css',
            theme: 'Dark',
            toolbar_bg: 'rgba(0,0,0,0)',
            overrides: {
                'paneProperties.background': 'rgba(0,0,0,0)',
                'paneProperties.backgroundType': 'solid',
                'paneProperties.legendProperties.showStudyTitles': false,
                'paneProperties.legendProperties.showStudyValues': false,
                'paneProperties.legendProperties.showSeriesTitle': false,
                'paneProperties.legendProperties.showStudyArguments': false,
                'paneProperties.legendProperties.showBarChange': false,
                'paneProperties.legendProperties.showBackground': false,
            },
            loading_screen: {
                backgroundColor: 'rgba(0,0,0,0)',
                foregroundColor: 'rgba(0,0,0,0) ',
            },
        } as ChartingLibraryWidgetOptions),
};

export default chartConfig;
